import { currency } from '../../utils/currency';
/** A figure the backend cannot compute yet arrives as null. */
export const amount = (value: number | null | undefined) => value == null ? 'Not ready' : currency(value);
